var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterblack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-66.000000, -288.000000) translate(65.000000, 286.000000) translate(1.673333, 3.380000)",
    stroke: "#000",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.666667, 0.000000)",
    strokeWidth: 1.56
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M0 2.21L3.38 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M8.58 2.21L21.58 2.21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.98,
    cy: 2.34,
    r: 2.34
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.246666, 9.946667) scale(-1, 1) translate(-11.246666, -9.946667) translate(0.246666, 7.280000)",
    strokeWidth: 1.56
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M0 2.21L3.38 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M8.58 2.21L21.58 2.21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.98,
    cy: 2.34,
    r: 2.34
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.666667, 14.820000)",
    strokeWidth: 1.56
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M0 2.21L3.38 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M8.58 2.21L21.58 2.21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.98,
    cy: 2.34,
    r: 2.34
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterblack);
export default __webpack_public_path__ + "static/media/Filter black.23f661081db6d1f9dc9f7abbcb97b274.svg";
export { ForwardRef as ReactComponent };